import * as React from 'react';
import { Button, LinkButton, Modal, UIHeading2, UIText1 } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import clsx from 'classnames';

import { useIsDesktop } from 'shared/utils/useIsDesktop';

import { useGetCPDModalOptions } from './hooks';

import styles from './CPDModal.css';

export const CPDModal: React.FC = () => {
  const isDesktop = useIsDesktop();
  const {
    isModalVisible,
    onModalClose,
    onDontShowAgainClick,
    onSellClick,
    onBuyClick,
    onRentClick,
    onSellAndBuyNewClick,
    onAnotherClick,
  } = useGetCPDModalOptions();

  if (!isModalVisible) {
    return null;
  }

  return (
    <Modal
      size="S"
      open={isModalVisible}
      onOpenChange={onModalClose}
      closeButtonProps={{
        theme: 'fill_light',
        title: 'Закрыть',
        icon: <IconActionClose16 color="current_color" data-testid="cpdModalCloseButton" />,
      }}
      data-testid="CPDModal"
    >
      <section className={clsx(styles['content'], !isDesktop && styles['mobile'])}>
        <div className={styles['image']} />
        <div className={styles['heading']} data-testid="cpdModalHeading">
          <UIHeading2>С чем нужна помощь риелтора?</UIHeading2>
          <UIText1>Подберём лучшего специалиста под ваш запрос</UIText1>
        </div>
        <div className={styles['controls']}>
          <Button theme="fill_secondary" data-testid="cpdModalSell" onClick={onSellClick}>
            Продать жильё
          </Button>
          <Button theme="fill_secondary" data-testid="cpdModalSellAndBuyNew" onClick={onSellAndBuyNewClick}>
            Продать и купить новое
          </Button>
          <Button theme="fill_secondary" data-testid="cpdModalBuy" onClick={onBuyClick}>
            Купить жильё
          </Button>
          <Button theme="fill_secondary" data-testid="cpdModalRent" onClick={onRentClick}>
            Сдать квартиру
          </Button>
          <Button theme="fill_secondary" data-testid="cpdModalAnotherRequest" onClick={onAnotherClick}>
            Другой запрос
          </Button>
          <LinkButton theme="fill_white_primary" data-testid="cpdModalDontShowAgain" onClick={onDontShowAgainClick}>
            Больше не показывать
          </LinkButton>
        </div>
      </section>
    </Modal>
  );
};
